import { render, staticRenderFns } from "./TheBaseApp.vue?vue&type=template&id=49c416ca&scoped=true"
import script from "./TheBaseApp.vue?vue&type=script&lang=js"
export * from "./TheBaseApp.vue?vue&type=script&lang=js"
import style0 from "./TheBaseApp.vue?vue&type=style&index=0&id=49c416ca&prod&scoped=true&lang=css"
import style1 from "./TheBaseApp.vue?vue&type=style&index=1&id=49c416ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c416ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
